let googleMapsPromise
const GOOGLE_MAPS_LOAD_TIMEOUT_MS = 15000

export function loadGoogleMaps() {
  if (window.google?.maps?.places) return Promise.resolve(window.google)
  if (googleMapsPromise) return googleMapsPromise

  const apiKey = document.querySelector('meta[name="google-maps-api-key"]')?.content
  if (!apiKey) return Promise.reject(new Error("Google Maps API key is unavailable."))

  googleMapsPromise = new Promise((resolve, reject) => {
    let existingScript = document.querySelector("script[data-google-maps-api]")
    if (existingScript?.dataset.googleMapsApiState === "failed") {
      existingScript.remove()
      existingScript = null
    }
    const script = existingScript || document.createElement("script")
    let timeout

    const cleanup = () => {
      window.clearTimeout(timeout)
      script.removeEventListener("load", loaded)
      script.removeEventListener("error", failed)
    }

    const loaded = () => {
      cleanup()
      if (window.google?.maps?.places) {
        script.dataset.googleMapsApiState = "loaded"
        resolve(window.google)
      } else {
        script.dataset.googleMapsApiState = "failed"
        reject(new Error("Google Maps loaded without the Places library."))
      }
    }
    const failed = () => {
      cleanup()
      script.dataset.googleMapsApiState = "failed"
      reject(new Error("Google Maps could not be loaded."))
    }

    script.addEventListener("load", loaded, { once: true })
    script.addEventListener("error", failed, { once: true })
    timeout = window.setTimeout(failed, GOOGLE_MAPS_LOAD_TIMEOUT_MS)

    if (!existingScript) {
      const url = new URL("https://maps.googleapis.com/maps/api/js")
      url.searchParams.set("key", apiKey)
      url.searchParams.set("libraries", "places")
      url.searchParams.set("loading", "async")
      script.src = url.toString()
      script.async = true
      script.dataset.googleMapsApi = "true"
      script.dataset.googleMapsApiState = "loading"
      document.head.appendChild(script)
    }
  }).catch((error) => {
    const failedScript = document.querySelector('script[data-google-maps-api][data-google-maps-api-state="failed"]')
    failedScript?.remove()
    googleMapsPromise = null
    throw error
  })

  return googleMapsPromise
}
